<div class="grid p-fluid flex-row-reverse dashboard-graph-grid">
  <div class="col-12">
    <p-card>
      <ng-template #header>
        <div class="m-4 mb-0 p-card-title flex flex-row justify-content-between">
          <strong>Generi e sottogeneri</strong>
          <div class="flex flex-row gap-2">
            <app-action-button type="add" label="Aggiungi genere" (click)="addGenre('Genre')" [textButton]="true"></app-action-button>
            <app-action-button type="add" label="Aggiungi sottogenere"
                               (click)="addGenre('SubGenre')" [textButton]="true"></app-action-button>
          </div>
        </div>
      </ng-template>
      <div class="flex flex-row gap-2 mb-4">
        <app-input type="text"
                   [(model)]="globalFilter"
                   [placeholder]="'Cerca per nome (IT/EN)'"
                   [showLength]="false"
                   [maxLength]="64"
                   class="mb-2"
        ></app-input>
        <p-toggle-button
          [(ngModel)]="showGenres"
          onLabel="Mostra generi principali"
          offLabel="Mostra generi principali">
        </p-toggle-button>
        <p-toggle-button
          [(ngModel)]="showSubGenres"
          onLabel="Mostra sottogeneri"
          offLabel="Mostra sottogeneri">
        </p-toggle-button>
      </div>
      <p-table #table styleClass="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
               [value]="genres()"
               [rows]="50"
               [rowsPerPageOptions]="[10, 20, 50, 100]"
               [totalRecords]="genres().length"
               [paginator]="true"
               [rowHover]="true"
               [loading]="loading"
               [autoLayout]="true"
               responsiveLayout="stack"
               [filterDelay]="300"
               [globalFilterFields]="['nameIt', 'nameEn']"
      >
        <ng-template pTemplate="header">
          <tr class="left-aligned small-row">
            <th>Nome (IT)</th>
            <th>Nome (EN)</th>
            <th>Tipologia</th>
            <th>Azioni</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          @let genre = obj(item);
          <tr>
            <td>{{ genre.name }}</td>
            <td>{{ genre.englishName }}</td>
            <td>
              <span [class]="genre.isSubGenre ? 'text-muted' : 'text-primary'">
                {{ genre.isSubGenre ? 'Sottogenere' : 'Principale' }}
              </span>
            </td>
            <td>
              <div class="flex flex-row gap-2">
                <p-button variant="text" (click)="editGenre(genre)">
                  <i class="pi pi-pencil"></i>
                </p-button>
                <p-button variant="text" (click)="deleteGenre(genre)">
                  <i class="pi pi-trash"></i>
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
